import { FormatFileIcon } from './FormatsIcons';
import HomeSectionAccordion from '../HomeSectionAccordion/HomeSectionAccordion';
import './style.css';

const Formats = () => {
  return (
    <section className="section formats">
      <div className="container">
        <div className="formats__wrapper">
          <HomeSectionAccordion
            id="formats"
            title="Форматы данных"
            collapsedSummary="Входные форматы облаков точек и форматы передачи результатов."
          >
            <div className="formats__panel">
            <article className="formats__column">
              <h2 className="formats__card-title">Входные форматы</h2>

              <ul className="formats__list">
                <li>
                  <FormatFileIcon />
                  <span>E57</span>
                </li>
                <li>
                  <FormatFileIcon />
                  <span>RCP / RCS</span>
                </li>
                <li>
                  <FormatFileIcon />
                  <span>LAS</span>
                </li>
              </ul>
            </article>

            <article className="formats__column">
              <h2 className="formats__card-title">Форматы передачи результатов</h2>

              <ul className="formats__list">
                <li>
                  <FormatFileIcon />
                  <span>DWG</span>
                </li>
                <li>
                  <FormatFileIcon />
                  <span>RVT</span>
                </li>
                <li>
                  <FormatFileIcon />
                  <span>IFC</span>
                </li>
                <li>
                  <FormatFileIcon />
                  <span>PDF</span>
                </li>
              </ul>
            </article>
            </div>

            <p className="formats__note">
              При необходимости согласуем работу и с другими форматами данных.
            </p>
          </HomeSectionAccordion>
        </div>
      </div>
    </section>
  );
};

export default Formats;
